export const messages = {
  en: {
    shopAppraiseManage: {
      title: 'Shop Appraise Management',
      queryConditions: 'Query Conditions',
      productName: 'Product Name',
      user: 'User',
      score: 'Score',
      content: 'Content',
      images: 'Images',
      commentTime: 'Comment Time',
      operations: 'Operations',
      reply: 'Reply',
      search: 'Search',
      reset: 'Reset',
      productComments: 'Product Comments',
      add: 'Add Comment',
      edit: 'Edit',
      delete: 'Delete',
      addTitle: 'Add Comment',
      editTitle: 'Edit Comment',
      deleteConfirm: 'Are you sure to delete this comment?'
    }
  },
  zh: {
    shopAppraiseManage: {
      title: '商品评价管理',
      queryConditions: '查询条件',
      productName: '商品名称',
      user: '用户',
      score: '评分',
      content: '内容',
      images: '图片',
      commentTime: '评论时间',
      operations: '操作',
      reply: '回复',
      search: '查询',
      reset: '重置',
      productComments: '商品评论',
      add: '新增评论',
      edit: '编辑',
      delete: '删除',
      addTitle: '新增评论',
      editTitle: '编辑评论',
      deleteConfirm: '确认删除该评论吗？'
    }
  }
}
